import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Icon } from '../../Icon';
import { Label } from './partials';
export var OrganizationBadge = function OrganizationBadge(_ref) {
  var entity = _ref.entity,
    size = _ref.size,
    _ref$withLink = _ref.withLink,
    withLink = _ref$withLink === void 0 ? true : _ref$withLink;
  var labelProps = withLink && entity && entity.web ? {
    as: AppLink,
    href: entity.web,
    target: '_top',
    title: "Ver ".concat(entity.displayName)
  } : {};
  return React.createElement(Label, labelProps, React.createElement(Icon, {
    image: "/image/".concat(entity.icon),
    type: "company",
    size: size,
    alt: entity.displayName
  }), React.createElement("span", null, entity && entity.displayName || ''));
};